import i18n, { i18n_t } from '@/locales/i18n';
const SMHApiErrCodeMap: Record<string, string> = {
  // 自定义域名相关错误
  DuplicateCustomDomain: i18n_t('仅允许绑定一个自定义域名'),
  DomainNotLicensed: i18n_t('当前自定义域名暂未备案，完成备案后方可进行配置'),
  DomainCertKeyNotMatch: i18n_t('证书与域名不匹配，请检查后重新填写'),
  InvalidSslCertKey: i18n_t('证书或密钥无效，请检查后重新填写'),
  CustomDomainNotFound: i18n_t('找不到自定义域名'),
  DomainSslCertKeyExpired: i18n_t('证书或密钥已过期'),
  DuplicateDomain: i18n_t('当前域名已被占用，请重新选择'),
  VirusFileNotAvailableDownload: i18n_t('该文件存在风险，暂不支持下载'),
  VirusFileNotAvailableAuthorize: i18n_t('该文件存在风险，暂不支持共享'),
  VirusFileNotAvailableShare: i18n_t('该文件存在风险，暂不支持分享'),
  VirusFileNotAvailable: i18n_t('该文件存在风险，不支持当前操作'),
  SensitiveWordFileNotAvailableDownload: i18n_t('该文件存在风险，暂不支持下载'),
  SensitiveWordFileNotAvailableShare: i18n_t('该文件存在风险，暂不支持分享'),
  SensitiveWordFileNotAvailableAuthorize: i18n_t('该文件存在风险，暂不支持共享'),
  SensitiveWordFileNotAvailable: i18n_t('该文件存在风险，不支持当前操作'),
  // status 400
  BadRequest: i18n_t('错误请求'),
  EmptyLibraryIdOrSecret: i18n_t('媒体库ID或密钥为空'),
  UserIdLengthExceed: i18n_t('用户ID长度超出限制'),
  ClientIdLengthExceed: i18n_t('客户端ID长度超出限制'),
  EmptyLibrarySecret: i18n_t('媒体库密钥为空'),
  EmptyLibraryId: i18n_t('媒体库ID为空'),
  NotMultiSpaceLibrary: i18n_t('该媒体库非多租户模式'),
  EmptyAccessToken: i18n_t('访问令牌为空'),
  EmptyPath: i18n_t('文件已被删除或移动至其他位置'),
  DirectoryNameLengthExceed: i18n_t('目录名长度超出限制，请修改'),
  DirectoryNotAllowed: i18n_t('目录名称不合法，请修改'),
  DirectoryLevelExceed: i18n_t('仅允许存在一级目录，请联系管理员修改'),
  EmptyFileName: i18n_t('文件名称为空，请重新设置'),
  FileNameLengthExceed: i18n_t('文件名称长度超过限制，请修改'),
  ExtnameNotAllowed: i18n_t('本目录不支持此类型文件'),
  UploadToRootDirectoryNotAllowed: i18n_t('不支持上传文件至根目录，请联系管理员修改'),
  InvalidSourceDirectory: i18n_t('源目录无效'),
  SourceDirectoryIsParentOfDestination: i18n_t('目标路径为源文件夹的子文件夹，请重新选择'),
  InvalidSourceFile: i18n_t('源文件无效'),
  InvalidSourcePath: i18n_t('源路径无效'),
  InvalidTargetFile: i18n_t('该文件为无效文件，请检查后重新上传'),
  InvalidDestinationPath: i18n_t('目标路径无效'),
  FileTypeNotMatched: i18n_t('目标文件类型与源文件不匹配'),
  MultipartUploadIncomplete: i18n_t('文件分段上传未完成'),
  QuotaLimitReached: i18n_t('可用存储额度不足'),
  LibraryQuotaLimitReached: i18n_t('可用存储额度不足'),
  QuotaCapacityRequired: i18n_t('本操作需要更多存储空间，请联系管理员'),
  QuotaCapacityInvalid: i18n_t('存储额度无效'),
  QuotaSpacesRequired: i18n_t('多租户空间需要分配空间额度'),
  ParamInvalid: i18n_t('参数无效'),
  SearchTooComplex: i18n_t('搜索关键词过于复杂，请精简后再搜索'),
  RecycleBinNotEnabled: i18n_t('误删恢复未开启'),
  InvalidConflictResolutionStrategy: i18n_t('指定的冲突解决策略无效或不受支持'),
  OrderByNotAllowed: i18n_t('排序字段无效'),
  OrderByTypeNotAllowed: i18n_t('排序方式无效'),
  DirectoryHistoryNotBeDeleted: i18n_t('最新版本不能够被删除'),
  SearchNotEnabled: i18n_t('搜索功能未开启'),
  BadCrc64: i18n_t('获取文件失败'),
  DocumentTypeNotSupport: i18n_t('暂不支持该文件类型'),
  InvalidTemplateName: i18n_t('该模板名称无效'),
  PersonalSpaceNotAllowed: i18n_t('未开启个人空间'),
  DirectoryHistoryNotFound: i18n_t('未找到历史版本'),
  InvalidBatchAllowlistInfo: i18n_t('批量导入用户表格表头信息不完整，请参考导入模板填写'),
  ChildTeamAsDestinationTeam: i18n_t('团队空间文件不可移交至其子团队空间'),
  QrCodeOrganizationNotMatch: i18n_t('二维码与当前登录企业不匹配，请使用该域名绑定的腾讯云企业网盘APP扫码'),
  NoOrganizationOfSpecifiedDomain: i18n_t('当前域名未关联企业'),
  InvalidAuthorityRoleId: i18n_t('权限角色不存在'),
  InvalidWeworkParams: i18n_t('企微配置测试失败，请检查后重新填写'),
  InvalidWeworkAuthCode: i18n_t('二维码无效或已过期，请重新登录'),
  InvalidWeworkCorpid: i18n_t('企业ID参数无效，请检查后重新填写'),
  InvalidWeworkCredential: i18n_t('Secret参数无效，请检查后重新填写'),
  InvalidWeworkAgentId: i18n_t('AgentId参数错误，请检查后重新填写'),
  EditFileSizeExceed: i18n_t('在线编辑文档不能超过 4M'),
  UserLimitReached: i18n_t('企业人员数量已达上限，请联系管理员'),
  AuthorizeMyselfNotAllowed: i18n_t('不支持对自己授权'),
  InvalidWeworkRedirectUrl: i18n_t('企微应用回调 URL 配置错误'),
  TaskNotDeletable: i18n_t('该任务不可被删除'),
  RootDirectoryNotAllowed: i18n_t('不支持对企业根目录执行该操作'),
  NoEnoughRemainingTrafficQuota: i18n_t('企业剩余可用流量额度不足'),
  DirectorySyncIdInvalid: i18n_t('同步任务 ID 不存在，云端路径已解除同步'),
  SyncFolderLocked: i18n_t('同步盘已被锁定，无法操作'),
  FileRemovedByQuota: i18n_t('文件因存储空间不足被删除'),
  ProcessTimeout: i18n_t('处理超时，请稍后再试'),
  DestUserSpaceQuotaLimited: i18n_t('所选用户空间额度不足，请重新选择'),
  ShareDownloadOrPreviewCountLimitOnlyAllowedSingleFile: i18n_t('下载或预览次数限制只支持单文件分享'),
  InvalidGraphicCaptcha: i18n_t('图形验证码无效'),
  DuplicatePropertyInParams: i18n_t('参数重复'),
  GroupOwnerCanNotExit: i18n_t('群组管理员不允许退出群组'),
  InvalidGroupName: i18n_t('群组名称不合法，请重新填写'),
  InvalidGroupUserAuthRoleId: i18n_t('群组用户授权信息错误'),
  MultipartUploadPartTooSmall: i18n_t('分块上传文件块过小'),
  SearchIdInvalid: i18n_t('搜索参数无效，请重新输入'),
  GroupOwnerSpaceNotFound: i18n_t('群主个人空间不存在'),
  OrganizationNotRegistered: i18n_t('当前账号未加入任何团队，请前往官网购买'),
  DeregisterNotAllowedForSuperAdmin: i18n_t('超级管理员不允许注销，请转交管理员身份后进行操作'),
  TargetOrganizationUserUnderDeregister: i18n_t('用户注销中，请启用后重新进行操作'),
  GetWechatUserInfoFailed: i18n_t('获取微信用户信息失败'),
  InvalidYufuParams: i18n_t('玉符参数校验失败，请检查后重新填写'),
  WeworkDelegateAppNotEnabled: i18n_t('当前企业暂未开通企业微信代开发应用功能'),
  WeworkIntegrationNotInstalled: i18n_t('当前企业暂未关联企业微信应用'),
  NoAuthToNameOfWeworkDelegateApp: i18n_t('未获取部门名称和员工姓名授权，请前往企业微信管理后台修改'),
  InactiveUserId: i18n_t('该用户当前未激活账号'),
  InatciveUserPhoneNotBind: i18n_t('未激活用户需前往 企业微信工作台-腾讯云企业网盘 绑定手机号'),
  DuplicateWeworkIntegration: i18n_t('清除配置后方可重新绑定应用'),
  DuplicateChannelOrgApplication: i18n_t('该手机号已领取此渠道体验账号'),
  CreateChannelOrgFailed: i18n_t('创建渠道体验版本失败'),
  RefreshTokenExpired: i18n_t('刷新 token 已过期'),
  ResponseTypeNotAllowed: i18n_t('第三方应用授权，返回类型参数不合法'),
  AuthorizationCodeExpired: i18n_t('应用授权码已过期'),
  AuthorizationCodeHasBeenUsed: i18n_t('应用授权码已被使用'),
  IpRuleNotFound: i18n_t('IP规则参数设置错误'),
  InvalidIpRange: i18n_t('当前IP规则的范围错误'),
  InvalidIpAddress: i18n_t('IP规则格式错误'),
  ApplyAuthorityHasBeenClosed: i18n_t('此审批单已被处理，请前往历史审批查看'),
  EmptyApplyDirectory: i18n_t('所选文件均已在审批流程中，请重新选择'),
  PreviewerWatermarLoginRequired: i18n_t('请退回外链分享页，刷新页面后登录并查看文件'),
  SensitiveWordIsMatching: i18n_t('敏感词添加过于频繁，请稍后再试'),
  // authorized error
  ApplicationNotFound: i18n_t('应用找不到或被删除'),
  RedirectUriNotMatchApplication: i18n_t('回调地址和应用配置的不匹配'),
  ScopeNotMatchApplication: i18n_t('接口范围和应用配置的不匹配'),
  // status 451
  ShareContentIsLoading: i18n_t('正在为你过滤无权限操作文件'),
  ShareContentNotAvailable: i18n_t('该文件存在风险，暂不支持查看'),
  FileContentIsLoading: i18n_t('正在为你过滤无权限操作文件'),
  // 文件审核中
  FileContentNotAvailable: i18n_t('该文件存在风险，暂不支持查看'),
  // 文件审核不通过
  DirectoryNameNotAvailable: i18n_t('当前文件名称无法保存'),
  CollectTitleAuditSensitive: i18n_t('当前文件标题无法保存'),
  CollectDescribesAuditSensitive: i18n_t('当前文件要求无法保存'),
  CollectNamingRulesAuditSensitive: i18n_t('当前文件自定义命名规则无法保存'),
  SensitiveNameRecognized: i18n_t('当前名称无法保存'),
  SensitiveOrgLogoRecognized: i18n_t('当前图片无法保存'),
  SensitiveUserLogoRecognized: i18n_t('当前用户头像无法保存'),
  IllegalFileName: i18n_t('暂不支持文件名带特殊字符“\\/:*?"<>|”的文件操作，请修改名称'),
  // NoEnoughRemainingQuota: '可分配存储额度不足', ???
  // status 403
  InvalidAccessToken: i18n_t('访问令牌无效/过期/不匹配'),
  AccessTokenNotMatchSpace: i18n_t('访问令牌不匹配'),
  NoPermission: i18n_t('您没有该操作的权限'),
  OrganizationNotEnableShare: i18n_t('企业已关闭分享功能，请联系管理员开启'),
  LibraryServiceTimeExpired: i18n_t('服务已到期，续期后方可继续使用'),
  OrganizationServiceTimeExpired: i18n_t('服务已到期，续期后方可继续使用'),
  MeetingOauthFailed: i18n_t('腾讯会议授权失败'),
  CreateMeetingFailed: i18n_t('创建腾讯会议失败'),
  PhoneNumberNotInSpecifiedOrganization: i18n_t('指定组织中未找到该手机号'),
  NoPermissionToOtherUserTask: i18n_t('无法操作其它用户发起的任务'),
  UserNotBindPhoneNumber: i18n_t('首次登录需要绑定手机号，请进行绑定'),
  FilePreviewCountLimitReached: i18n_t('文件预览次数已达上限'),
  FileDownloadCountLimitReached: i18n_t('文件下载次数已达上限'),
  DirectoryNotAllowedForSingleFileShare: i18n_t('会中分享不允许选择文件夹'),
  ShareGroupLimit: i18n_t('协作群组数量达到上限，升级套餐可解锁更多群组'),
  ShareGroupUserCountLimit: i18n_t('协作群组成员达到上限，升级套餐可解锁更大群组'),
  UserNotInGroup: i18n_t('该用户不在群组中'),
  OrganizationShareLinkLimitReached: i18n_t('创建外链数量达到上限，升级套餐解锁更多'),
  OrganizationTeamAdminNotAllowed: i18n_t('此套餐暂不支持团队管理员'),
  GetShareGroupDynamicNotAllowed: i18n_t('此套餐暂不支持获取共享群组动态'),
  OverseasPhoneNumberNotAllowed: i18n_t('该企业暂不支持海外手机号码'),
  OperationNotAllowedForOverseasPhoneNumberToken: i18n_t('该企业暂不支持海外手机号码'),
  ShareManageNotAllowed: i18n_t('此套餐暂不支持分享管理'),
  WatermarkManageNotAllowed: i18n_t('此套餐暂不支持水印管理'),
  ResignationTransferNotAllowed: i18n_t('此套餐暂不支持数据转接'),
  WechatIntegrationNotAllowed: i18n_t('此套餐暂不支持企业微信同步'),
  LogManageNotAllowed: i18n_t('此套餐暂不支持日志'),
  StatsReportNotAllowed: i18n_t('此套餐暂不支持统计数据'),
  DirectoryLocalSyncNotAllowed: i18n_t('此套餐暂不支持同步盘'),
  DirectoryHistoryNotAllowed: i18n_t('此套餐暂不支持历史版本'),
  DirectoryHistoryCountLimitReached: i18n_t('文件历史版本达到上限，升级套餐解锁更多'),
  OnlineEditNotAllowed: i18n_t('不支持在线编辑文档'),
  RecoveryTimeExceeded: i18n_t('已超过可恢复时间，无法恢复'),
  CreateTeamSpaceNotAllowed: i18n_t('不支持团队空间'),
  LibraryInitializing: i18n_t('企业初始化中，请耐心等待'),
  DuplicateBindWechat: i18n_t('该微信已绑定其他手机号'),
  UserBindPhoneNumberFailed: i18n_t('绑定手机号码失败'),
  WechatOauthFailed: i18n_t('微信授权失败'),
  LibraryNotRegistered: i18n_t('媒体库未注册'),
  YufuSSOLoginNotAllowed: i18n_t('未开启玉符单点登录'),
  YufuOauthFailed: i18n_t('玉符授权认证失败，请联系管理员在后台管理中检查SSO登录-clientID与密钥配置'),
  GetYufuUserInfoFailed: i18n_t('获取玉符用户信息失败'),
  GetYufuWellknownFailed: i18n_t('获取 wellknown 信息失败，请检查后重新填写'),
  DuplicateBindYufu: i18n_t('当前玉符账号已绑定手机号码，无需再次绑定'),
  YufuOauthDuplicateBindPhoneNumber: i18n_t('当前手机号码已绑定其他玉符账号，请更换手机号进行绑定'),
  DuplicateBindYufuConfig: i18n_t('当前租户ID已绑定其他企业，请检查后重新绑定'),
  OrganizationUserInactive: i18n_t('用户未激活，请联系管理员处理'),
  BatchDownloadFileContentIsLoading: i18n_t('部分文件正在加载，请稍后重试'),
  BatchDownloadFileContentNotAvailable: i18n_t('下载中的文件包含风险文件，请重新选择'),
  WatermarkTextContainsSensitiveWord: i18n_t('当前水印包含敏感信息，请重试'),
  IpIsNotAllowed: i18n_t('当前网络已被管理员设定为不可登录使用，需登录请联系管理员'),
  // status 404
  LibraryNotFound: i18n_t('媒体库不存在'),
  SpaceNotFound: i18n_t('租户空间不存在'),
  WrongLibraryIdOrSecret: i18n_t('媒体库ID或密钥错误'),
  DirectoryNotFound: i18n_t('文件夹不存在'),
  CollectDirectoryNotFound: i18n_t('文件夹不存在，请联系发起者'),
  UploadNotFound: i18n_t('未找到上传文件或不支持访问'),
  NotMultipartUpload: i18n_t('该文件并非分段上传文件'),
  UploadIncomplete: i18n_t('上传未完成'),
  FileNotFound: i18n_t('文件不存在'),
  PathNotFound: i18n_t('路径不存在'),
  RoleNotFound: i18n_t('该角色不存在'),
  SourceDirectoryNotFound: i18n_t('源文件夹不存在或被移动至其他位置'),
  SourceFileNotFound: i18n_t('源文件不存在或被移动至其他位置'),
  SourcePathNotFound: i18n_t('源路径不存在'),
  NoQuota: i18n_t('存储额度不足'),
  RecycledItemNotFound: i18n_t('误删恢复中未查询到该文件（夹）'),
  SearchIdNotFound: i18n_t('搜索id无效'),
  FavoriteGroupNotFound: i18n_t('未找到对应收藏夹'),
  StoreDataNotFound: i18n_t('缓存已清空，获取数据失败'),
  noOrganizationWeworkIntegration: i18n_t('该企业未开启企微登录功能，请联系管理员'),
  ShareDirectoryNotFound: i18n_t('文件（夹）已被删除'),
  WeworkUserIdNotFound: i18n_t('未在企微中查询到该用户'),
  GraphicCaptchaNotFound: i18n_t('图形验证码未上传'),
  GroupInvitationNotCreated: i18n_t('未创建群组邀请码'),
  OrgInvitationNotCreated: i18n_t('未创建企业邀请码'),
  NoPurchaseRecord: i18n_t('未找到订单信息'),
  InvitationNotExist: i18n_t('邀请无效'),
  GroupNotFound: i18n_t('群组不存在'),
  InvitationCodeInvalidOrExpired: i18n_t('邀请码无效或已过期，请联系分享人重新获取'),
  InvitationGroupNotFound: i18n_t('该邀请群组已被删除'),
  InvitingOrganizationServiceTimeExpired: i18n_t('邀请企业已过期，续费成功后方可加入'),
  SharingOrganizationServiceTimeExpired: i18n_t('邀请企业已过期，续费成功后方可获取分享文件'),
  InvitationOrganizationNotFound: i18n_t('该邀请企业已被删除'),
  NoviceGuidanceNotFound: i18n_t('无法找到新手引导数据'),
  YufuUserIdNotFound: i18n_t('玉符用户 openId 同步失败'),
  YufuConfigNotFound: i18n_t('网盘后台未找到玉符配置'),
  ApplicationAuthorizationNotFound: i18n_t('未找到第三方应用授权信息'),
  WatermarkTextNotFound: i18n_t('水印信息不存在'),
  INodeNotFound: i18n_t('远端同步文件夹被删除，同步出错'),

  // status 500
  InternalServerError: i18n_t('处理请求时出错'),
  SearchTimeout: i18n_t('搜索超时'),
  WeworkParentTeamSyncFail: i18n_t('企微父级团队同步失败'),
  WeworkFreqLimit: i18n_t('企微同步超过频率限制（企微接口的限制，一般不会遇到）'),
  GetWeworkTeamMemberFailed: i18n_t('获取企微团队成员失败'),
  YufuParentTeamSyncFail: i18n_t('同步玉符通讯录时，父团队同步失败'),
  GetYufuTeamMemberFailed: i18n_t('同步玉符通讯录时，成员获取失败'),
  DuplicateMeetingOauth: i18n_t('重复绑定腾讯会议账号'),
  // status 409
  SameSpaceIdTransfered: i18n_t('只允许移交至父级及以上层级部门'),
  SameNameDirectoryOrFileExists: i18n_t('存在同名文件（夹），请更换名称'),
  DuplicateQuota: i18n_t('创建额度失败，请稍后再试或联系客服'),
  CircleSymlink: i18n_t('循环符号链接错误'),
  TargetBeingCoEdited: i18n_t('目标文件正被编辑'),
  DuplicateAllowlistOrUser: i18n_t('同一手机号或账号对应用户在该企业已存在'),
  DuplicatePurchaseRecord: i18n_t('系统繁忙请稍后重试'),
  DuplicateInvitationRecord: i18n_t('系统繁忙请稍后重试'),
  DuplicateRoleName: i18n_t('自定义角色名称重复'),
  DuplicateOrgUser: i18n_t('当前用户在该企业已存在'),
  CreateSensitiveWordFailed: i18n_t('创建敏感词失败'),
  DuplicateSensitiveWord: i18n_t('重复创建相同的敏感词'),
  // 文件同步远端错误
  DuplicateDirectorySync: i18n_t('该文件夹已被设置为同步盘，请重新选择'),
  SyncChildRemoteFolderExist: i18n_t('远端父目录已被设置为同步盘'),
  ChildDirectorySyncExist: i18n_t('所选文件夹的某子文件夹已被设为同步盘，请重新选择'),
  ParentDirectorySyncExist: i18n_t('所选文件夹的某父级文件夹已被设为同步盘，请重新选择'),
  DirectorySyncNotFound: i18n_t('该同步任务不存在或已被取消'),
  // 账密登录错误码
  InvalidAccountPassword: i18n_t('密码格式不正确，请重新输入'),
  IncorrectPassword: i18n_t('密码不正确，请重新输入'),
  SamePassword: i18n_t('新密码与旧密码一致，请重新设置'),
  InvalidAccountName: i18n_t('账号格式不正确，请重新输入'),
  IncorrectPasswordResetToken: i18n_t('重置密码 token 不合法'),
  ExpiredPasswordResetToken: i18n_t('重置密码 token 过期'),
  UserAccountNameNotMatched: i18n_t('账号错误，请重新输入'),
  UserLoginConfigNotFound: i18n_t('当前账号未加入企业，请联系企业管理员'),
  DuplicateUserName: i18n_t('账号名已被占用，请重新输入'),
  IncorrectOriginalPassword: i18n_t('原始密码不正确，请重新输入'),

  // 账号关联错误码
  LoginFlagShowNotFound: i18n_t('配置项企业loginFlagShow缺失'),
  OpenLDAPLoginNotAllowed: i18n_t('企业未开启 Open LDAP'),
  EmptyLDAPType: i18n_t('配置项 Open LDAP type 缺失'),
  WindowsAdLoginNotAllowed: i18n_t('企业未开启 Windows AD'),
  EmptyAccountNameOrPassword: i18n_t('未填写账号名或密码'),
  UserAccountDnNoFound: i18n_t('账号 DN 不存在'),
  LoginTypeNotSupport: i18n_t('当前企业不支持此登录方式'),
  AccountBindPhoneFailed: i18n_t('绑定手机号失败'),
  ProtocolNotSupport: i18n_t('不支持的协议'),
  ConnectProcotolNotFound: i18n_t('未找到需要校验联通性的协议'),
  SSOWayNotFound: i18n_t('企业未添加第三方登录方式'),
  OrganizationAccountIntegrationNotFound: i18n_t('未找到该企业的账户协议配置'),
  OrganizationAccountPluginNotFound: i18n_t('网盘暂不支持该插件'),
  AccountPluginImportError: i18n_t('协议插件导入失败'),
  SyncWayNotFound: i18n_t('企业未添加同步协议'),
  EmptyLDAPConfig: i18n_t('配置项 Open LDAP / Windows AD 缺失'),
  LoginFlagNotFound: i18n_t('登录名字段不存在'),
  PluginNotFound: i18n_t('账号协议不存在'),
  PluginInvokerNotFound: i18n_t('账号协议调用不存在'),
  CasVerifyFailed: i18n_t('CAS账号验证失败'),
  OauthVerifyFailed: i18n_t('OAuth账号验证失败'),
  SSOEndpointConnectError: i18n_t('SSO登录地址访问失败'),
  SSOEndpointCheckError: i18n_t('SSO登录地址校验失败'),
  TokenEndpointConnectError: i18n_t('Token校验地址访问失败'),
  TokenEndpointCheckError: i18n_t('Token地址校验失败'),
  TokenEndpointAccessError: i18n_t('从token地址获取数据失败'),
  UserInfoEndpointConnectError: i18n_t('获取用户信息地址访问失败'),
  UserInfoEndpointCheckError: i18n_t('获取用户信息地址校验失败'),
  UserInfoEndpointAccessError: i18n_t('从用户信息地址获取数据失败'),
  JwksUriConnectError: i18n_t('JwksUri地址访问失败'),
  JwksUriCheckError: i18n_t('JwksUri校验失败'),
  GetLoginFlagValueError: i18n_t('从用户信息中获取login flag失败'),
  VerifyJwtWithJwkError: i18n_t('使用jwk校验jwt失败'),
  VerifyJwtWithSecretError: i18n_t('使用secret校验jwt失败'),
  RequestFrequencyLimitExceeded: i18n_t('请求太频繁，请稍后再试'),
  GetUserStatusFailed: i18n_t('获取用户状态失败'),
  UserStatusEndpointNotFound: i18n_t('用户状态地址不存在'),
};

const SMHUserApiErrCodeMap: Record<string, string> = {
  // status 400px
  InvalidPhoneNumber: i18n_t('国家代码或手机号码不合法'),
  IncompletePhoneNumber: i18n_t('国家代码或手机号码不完整'),
  DeviceIdLengthExceed: i18n_t('设备ID长度超过限制'),
  InvalidUserId: i18n_t('用户ID无效'),
  InvalidOrganizationId: i18n_t('用户未加入企业'),
  InvalidOrganizationName: i18n_t('组织名称无效，请重新输入'),
  InvalidTeamName: i18n_t('部门名称无效，请重新输入'),
  InvalidUserName: i18n_t('用户昵称不符合要求，请重新输入'),
  InvalidUserExtensionData: i18n_t('用户扩展数据无效'),
  InvalidSpaceConfig: i18n_t('空间配置数据无效'),
  InvalidBatchAllowlist: i18n_t('未填写名称或电话或部门（必填）'),
  InvalidSpaceOrDirectoryPath: i18n_t('未找到该空间或目录路径'),
  ChildTeamAsDestTeam: i18n_t('不允许移动父级部门至子部门？'),
  EmptyUserToken: i18n_t('用户访问令牌为空'),
  EmptyPath: i18n_t('目录为空'),
  DestTeamSpaceQuotaLimited: i18n_t('目标位置存储额度不足'),
  QuotaCapacityInvalid: i18n_t('存储额度无效'),
  TaskNotCancelable: i18n_t('任务不可被取消或已完成'),
  EmptyAllowlistData: i18n_t('文件为空'),
  ShareDirectoryPathInvalid: i18n_t('所选文件需位于同一目录下'),
  ShareExtractionCodeInvalid: i18n_t('验证码无效，请重新输入'),
  ShareExpired: i18n_t('分享过期了'),
  ShareLinkIsDisabled: i18n_t('分享被禁用'),
  ShareExpireTimeInvalid: i18n_t('期限不支持设置超过50年'),
  QuotaCapacityLessThanSize: i18n_t('分配的额度不可小于当前已用额度'),
  QrCodeInvalidOrExpired: i18n_t('二维码无效或过期'),
  QrCodeNotScanned: i18n_t('二维码没有被扫描'),
  QrCodeNotConfirmed: i18n_t('二维码没有被确认'),
  StoreDataNotMatchUserToken: i18n_t('存储的 Code 数据和 userToken 不匹配'),
  StoreDataNotMatchAccessToken: i18n_t('存储的 Code 数据和 accessToken 不匹配'),
  NotAllowSaveToNetDisc: i18n_t('不允许被保存到网盘'),
  SameNameTag: i18n_t('文件标签已存在'),
  UserPhoneNumberUnchanged: i18n_t('该手机号与当前手机号相同'),
  CollectExpireTimeInvalid: i18n_t('任务有效期超过范围，请重新设置'),
  CollectNotFound: i18n_t('当前收集任务已关闭'),
  CollectUpdateFailed: i18n_t('收集任务变更失败，请重试'),
  CollectInvalidOrExpired: i18n_t('当前收集任务已过期'),
  CollectDirectoryNotBelongUser: i18n_t('填写命名规则已重复，请修改后重试'),
  DownloadFileNotInCollectTask: i18n_t('范例文件已变更,请刷新后尝试'),
  SameApplyAuthorityDirectory: i18n_t('申请的权限不可与现有权限重复，请重新选择'),
  ApplyDirectoryNotAllowed: i18n_t('暂无申请权限，请联系管理员处理'),
  ApplyAuthorityHasBeenClosed: i18n_t('申请单状态已改变，请刷新页面后重试'),
  CanNotModifyOthersApplyAuthority: i18n_t('无权操作此审批单'),
  ApplyAuthorityNotFound: i18n_t('申请单无法查看，请刷新后重试'),
  DuplicateTeamName: i18n_t('团队名称已存在，请重新输入'),
  FileSizeExceeded: i18n_t('文件大小超过阈值，上传失败'),
  ParentTeamIsNoSpace: i18n_t('该目录不支持创建下级团队空间'),
  AccountParentTeamSyncFail: i18n_t('父团队同步失败'),
  GetSupwisdomDepartmentFailed: i18n_t('获取树维组织架构失败'),
  GetSupwisdomUsersFailed: i18n_t('获取树维组织架构成员失败'),
  GetSupwisdomTokenFailed: i18n_t('获取树维 token 失败'),
  PluginNotFound: i18n_t('账号协议不存在'),
  PluginInvokerNotFound: i18n_t('账号协议调用不存在'),
  ConnectError: i18n_t('连接失败'),
  TokenEndpointConnectError: i18n_t('token 地址访问失败'),
  TokenEndpointCheckError: i18n_t('token 地址校验失败'),
  UserInfoEndpointCheckError: i18n_t('获取用户信息地址校验失败'),
  DataEndpointCheckError: i18n_t('获取数据地址校验失败'),
  UnsupportedUrlHost: i18n_t('暂不支持该 URL 域名/IP'),
  UnsupportedUrlProtocol: i18n_t('暂不支持该 URL 协议'),
  AccountUserIdNotFound: i18n_t('第三方账号ID不存在'),
  DuplicateAccountUserId: i18n_t('第三方账号ID重复'),
  // status 403
  DuplicateBindPhoneNumber: i18n_t('此手机号码已绑定其他微信号'),
  MeetingOauthDuplicateBindPhoneNumber: i18n_t('该会议账号已绑定其他手机号'),
  PhoneNumberNotInAllowlist: i18n_t('您未加入任何企业，请访问 官网https://pan.tencent.com/ 购买企业版后使用'),
  SmsFrequencyLimit: i18n_t('验证码获取过于频繁，请稍后再试'),
  SearchServiceBusy: i18n_t('搜索服务繁忙，请稍后再试'),
  UserNotInOrganization: i18n_t('用户未加入该企业或未登录'),
  UserNotInAllowlist: i18n_t('用户未加入该企业'),
  SmsCodeInvalidOrExpired: i18n_t('验证码无效或已过期，请重新获取'),
  WrongSmsCode: i18n_t('验证码错误，请重新输入'),
  SmsCodeVerificationExceeded: i18n_t('验证码已过期，请重新获取'),
  InvalidUserToken: i18n_t('用户访问令牌无效或过期'),
  UserDisabled: i18n_t('您已被该组织禁用，请联系组织管理员'),
  UserAccountDisabled: i18n_t('该账号已被冻结，请启用账号后进行操作'),
  UserNotAllowed: i18n_t('您未加入任何组织或被组织删除，请联系组织管理员'),
  FileTypeNotAllowed: i18n_t('不支持上传该类型文件'),
  InvalidFilePath: i18n_t('文件路径无效'),
  RootTeamOperationNotAllowed: i18n_t('普通用户无根目录操作权限'),
  NoPermission: i18n_t('您没有该操作的权限'),
  NoSpecifiedPermission: i18n_t('操作无权限'),
  NoSuperAdminPermission: i18n_t('仅超级管理员可进行该操作'),
  NoTeamPermission: i18n_t('无该部门操作权限'),
  InvalidShareAccessToken: i18n_t('验证码失效，请刷新页面重新操作'),
  // SmsCodeFailed: '验证码错误，请重新输入', ???
  // status 404
  OrganizationNotFound: i18n_t('未找到该组织'),
  TaskNotFound: i18n_t('未查询到该任务'),
  CanNotLoadAllowlistFile: i18n_t('导入白名单文件加载失败'),
  ShareInfoNotFound: i18n_t('文件已被删除或移动'),
  NoPersonalSpace: i18n_t('无个人存储空间'),
  NoSpace: i18n_t('未找到该空间'),
  NoOrganizationUser: i18n_t('未查询到该用户'),
  OrganizationTeamNotFound: i18n_t('未查询到该部门'),
  DestOrganizationTeamNotFound: i18n_t('未查询到目标部门？'),
  UserNotFound: i18n_t('未找到指定用户'),
  UploadIncomplete: i18n_t('上传未完成'),
  DirectorySyncNotFound: i18n_t('该同步任务不存在或已被取消'),
  TagNotFound: i18n_t('文件标签未找到'),
  PhoneNumberInSmsBlackList: i18n_t('该手机号已将腾讯云通知列入免打扰，若需接受短信验证码，请前往腾讯云官网咨询处理'),
  // status 409
  DuplicateRecord: i18n_t('存在重复数据'),
  DuplicateTeamRecord: i18n_t('团队名称已存在，请重新输入'),
  DuplicateUserPhoneNumber: i18n_t('手机号码已被其他用户使用'),
  DuplicateFavoriteRecord: i18n_t('文件（夹）已加入收藏列表'),
  DuplicateDirectorySync: i18n_t('该文件夹已被设置为同步盘，请重新选择'),
  ChildDirectorySyncExist: i18n_t('所选文件夹的某子文件夹已被设为同步盘，请重新选择'),
  ParentDirectorySyncExist: i18n_t('所选文件夹的某父级文件夹已被设为同步盘，请重新选择'),
  // status 451
  SensitiveContentRecognized: i18n_t('该文件存在敏感字段'),
  // status 499
  TaskCancelled: i18n_t('任务已被取消'),
  TaskIsCancelled: i18n_t('任务已被取消'),
  // status 500
  SignOutFail: i18n_t('登出请求出错'),
  SendSmsFailed: i18n_t('发送验证码出错'),
  SmartMediaHostingError: i18n_t('SMH请求出错'),
  NoDefaultRoleFound: i18n_t('未分配默认角色'),
  SpaceAllocationFail: i18n_t('分配存储空间失败'),
  InternalServerError: i18n_t('处理请求时出错'),
  FreeOfficialAccountChannelUnavailable: i18n_t('免费版活动已结束，请前往腾讯云官网领取试用'),
  ApplicationFrequencyLimitReached: i18n_t('当前活动申请人数较多，请稍后尝试'),
  FreeOfficialAccountQuotaLimitReached: i18n_t('今日免费版申请名额已满，请明天继续尝试'),
  TooManyFiles: i18n_t('批量下载超出限制，请前往PC电脑端网盘操作'),
};
const COSErrCodeMap: Record<string, string> = {
  EntitySizeNotMatch: i18n_t('请求体大小与 Content-Length 请求头不符'),
  EntityTooLarge: i18n_t('上传的对象大小超过规定的最大值。'),
  EntityTooSmall: i18n_t('上传的对象大小不足规定的最小值'),
  ExpiredToken: i18n_t('临时密钥 Token 已过期'),
  InvalidArgument: i18n_t('请求参数计算错误'),
  InvalidDigest: i18n_t('Content-MD5 值计算错误'),
  ListPartUploadIdIsEmpty: i18n_t('UploadId 为空'),
  RequestTimeTooSkewed: i18n_t('本地时间与服务器时间相差过大'),
  NoSuchUpload: i18n_t('上传时指定的 UploadId 不存在'),
  QuotaConflict: i18n_t('配额冲突'),
  InternalError: i18n_t('服务端内部错误'),
  SlowDown: i18n_t('请降低访问频率'),
  no_permissions_to_download: i18n_t('没有下载权限'),
  remote_file_not_found: i18n_t('远端文件不存在'),
  FileSizeZero: i18n_t('文件大小为空'),
  EPERM: i18n_t('操作无权限'),
  AccessDenied: i18n_t('无权限'),
};

const SMHSyncApiErrCodeMap: Record<string, string> = {
  SyncTaskNotFound: i18n_t('远端同步任务不存在'),
};

const SMHInterfaceMap: Record<string, string> = {
  'SMH.localFileNotFound': i18n_t('本地文件不存在'),
  'SMH.remoteFileHasChanged': i18n_t('远端文件已被修改'),
  'SMH.downloadMultiPart': i18n_t('分块下载失败'),
  'SMH.download_check_size_not_match': i18n_t('本地下载失败'),
  'SMH.uploadFile': i18n_t('简单上传失败'),
  'COS.putObject': i18n_t('简单上传失败'),
  'NODE.getChunkETag': i18n_t('本地计算Etag失败'),
  'NODE.getUUID': i18n_t('本地计算 uuid 失败'),
  'NODE.GetFileStatError': i18n_t('本地文件检查失败'),
  'NODE.FileContentChanged': i18n_t('本地文件已被修改'),
  'SMH.uploadMultiPartFile': i18n_t('初始化分块上传失败'),
  'SMH.computedAllUploadData': i18n_t('计算分块上传信息失败'),
  'COS.uploadPart': i18n_t('分块上传文件失败'),
  'SMH.updateMultiPartFileInfo': i18n_t('分块续传失败'),
  'SMH.confirmUploadFile': i18n_t('完成分块上传失败'),
  'SMH.cancelFileUpload': i18n_t('取消上传失败'),
};
const SMHErrorCodeMap = {
  ...SMHApiErrCodeMap,
  ...SMHUserApiErrCodeMap,
  ...SMHSyncApiErrCodeMap,
  ...COSErrCodeMap,
  ...SMHInterfaceMap,
};

export default SMHErrorCodeMap;

export function changeSMHErrorCodeMapLanguage() {
  // eslint-disable-next-line no-restricted-syntax
  for (const item in SMHErrorCodeMap) {
    SMHErrorCodeMap[item] = i18n_t(SMHErrorCodeMap[item]);
  }
}
